<span [ngStyle]="{'color': textColor}" *ngIf="visible" >
    {{value}}
</span>